//
// The 47-index autotile bitmask (https://github.com/tlhunter/node-autotile).
//
// A leaf with no imports: autotiler.ts computes indices with it, and autotile_library.ts decodes
// them, and autotiler.ts also reads the wall definitions out of autotile_library.ts -- so the
// table cannot live in either without an import cycle.
//
export const NW = Math.pow(2, 0)
export const N = Math.pow(2, 1)
export const NE = Math.pow(2, 2)
export const W = Math.pow(2, 3)
export const E = Math.pow(2, 4)
export const SW = Math.pow(2, 5)
export const S = Math.pow(2, 6)
export const SE = Math.pow(2, 7)

/** Neighbour sum -> autotile index. A corner counts only when both of its sides are filled. */
export const BITMASK: Record<number, number> = {
    2: 1,
    8: 2,
    10: 3,
    11: 4,
    16: 5,
    18: 6,
    22: 7,
    24: 8,
    26: 9,
    27: 10,
    30: 11,
    31: 12,
    64: 13,
    66: 14,
    72: 15,
    74: 16,
    75: 17,
    80: 18,
    82: 19,
    86: 20,
    88: 21,
    90: 22,
    91: 23,
    94: 24,
    95: 25,
    104: 26,
    106: 27,
    107: 28,
    120: 29,
    122: 30,
    123: 31,
    126: 32,
    127: 33,
    208: 34,
    210: 35,
    214: 36,
    216: 37,
    218: 38,
    219: 39,
    222: 40,
    223: 41,
    248: 42,
    250: 43,
    251: 44,
    254: 45,
    255: 46,
    0: 47,
}

// The neighbour sum each index stands for (the inverse of BITMASK), for anything that has to read
// an index back into the rims and notches it encodes -- see decodeAutotileIndex in
// autotile_library.ts.
const INDEX_TO_BITMASK: Record<number, number> = {}
Object.keys(BITMASK).forEach(sum => (INDEX_TO_BITMASK[BITMASK[sum]] = Number(sum)))
export const autotileIndexBitmask = (index: number): number | undefined => INDEX_TO_BITMASK[index]
